import { useEffect, useState } from 'react';
import { BOOT_STALLED_MS } from '~/boot-timeouts';
import { useStore } from '~/contexts';
export function useBootStalled() {
    let stalledAfterMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : BOOT_STALLED_MS;
    const authFlowDone = useStore((state)=>state.authFlowDone);
    const [stalled, setStalled] = useState(false);
    useEffect(()=>{
        if (!authFlowDone) {
            const stallTimer = setTimeout(()=>setStalled(true), stalledAfterMs);
            return ()=>clearTimeout(stallTimer);
        }
    }, [
        authFlowDone,
        stalledAfterMs
    ]);
    return stalled;
}
